<script setup lang="ts">
import type { HeaderProps } from '@/components/PortalHeader';

import { HERO_LAYOUT } from '~~/utils/symbols';

const variant = shallowRef<HeaderProps['variant']>('translucide');

provide(HERO_LAYOUT, {
	headerVariant: variant
});
</script>

<template>
	<div class="min-h-screen overflow-y-auto">
		<PortalHeader :variant="variant" class="fixed top-0 z-50 h-20" />

		<main class="h-max min-h-screen">
			<slot />
		</main>

		<Container class="bg-primary-light-4 py-0">
			<NavigationSectionNavigation />
		</Container>
		<Container class="bg-primary py-0!">
			<PortalFooter />
		</Container>
	</div>
</template>
